import { computed, inject, Injectable, Signal } from '@angular/core';
import { SamlResponse } from '../../../models/order/saml/saml.model';
import { LicResponse } from '../../../models/order/lic/lic.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store, Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { EncryptDecryptService } from '../../../services/encrypt-decrypt.service';
import { EnvironmentService } from '../../../services/environment.service';
import { AddSamlPayloadAction, AddLicPayloadAction, OrderResumeState } from './order-resume.state';

@Injectable({
  providedIn: 'root'
})
export class OrderResumeStateService {
    #store: Store = inject(Store)
    #encryptDecryptService: EncryptDecryptService = inject(EncryptDecryptService)
    #environmentService: EnvironmentService = inject(EnvironmentService)

    @Select(OrderResumeState.SamlResponse) private samlPayloadSelector$: Observable<string>
    @Select(OrderResumeState.LicResponse) private licPayloadSelector$: Observable<string>

    #samlPayloadSignal: Signal<string>
    #licPayloadSignal: Signal<string>
    constructor() {
        this.#samlPayloadSignal = toSignal(this.samlPayloadSelector$) as Signal<string>
        this.#licPayloadSignal = toSignal(this.licPayloadSelector$) as Signal<string>
    }

    setSamlPayload(response: SamlResponse) {
        this.#store.dispatch(new AddSamlPayloadAction(response))
    }

    setLicPayload(response: LicResponse) {
        this.#store.dispatch(new AddLicPayloadAction(response))
    }

    getSamlPayload = computed(() => {
        return this.#encryptDecryptService.decrypt<SamlResponse>(this.#samlPayloadSignal(), this.#environmentService.sessionDecryptKey)
    })

    getLicPayload = computed(() => {
        return this.#encryptDecryptService.decrypt<LicResponse>(this.#licPayloadSignal(), this.#environmentService.sessionDecryptKey)
    })

    reset() {
        this.setSamlPayload(null);
        this.setLicPayload(null);
    }
}
